import React, { Component } from 'react';
import PropTypes from 'prop-types';

const ExtraServicesHOC = (C) => {
  class ExtraServicesComp extends Component {
    static getServices(list) {
      return list.filter(service => service.serviceGroup !== 301 || (service.serviceGroup === 301 && service.type === 'OWNER')).sort((serviceA, serviceB) => serviceA.serviceId > serviceB.serviceId ? 1 : -1);
    }

    static validate(props) {
      return Promise.all([
        props.validatorFactory().then(factory => factory.getServicesValidator(props.order,
          props.appearance))
          .then(validator => validator()),
      ]);
    }

    static show(props) {
      return !props.order.services ? false :
        !!ExtraServicesComp.getServices(props.order.services).length;
    }

    render() {
      const services = ExtraServicesComp.getServices(this.props.order.services);

      return !ExtraServicesComp.show(this.props) ? null : (
        <C
          rental = {this.props.rental}
          errors={this.props.errors}
          onChange={this.props.actions.updateExtraServices}
          salesMarket={this.props.order.salesMarket}
          selectedFinalCleaning={this.props.appearance.selectedFinalCleaning}
          services={services}
          validateFinalCleaning={() => this.props.validatorFactory().then(factory => factory.getServicesValidator(this.props.order,
    this.props.appearance))}
>
          {this.props.children}
        </C>
      );
    }
  }

  ExtraServicesComp.PropTypes = {

    actions:PropTypes.shape({
      updateExtraServices:PropTypes.func.isRequired,
      setSelectedFinalCleaning:PropTypes.func.isRequired,
    }).isRequired,
    appearance:PropTypes.shape({
      selectedFinalCleaning:PropTypes.bool.isRequired,
    }).isRequired,
    children: PropTypes.node,
    errors:PropTypes.object,
    order: PropTypes.shape({
      services: PropTypes.array,
    }).isRequired,
    validatorFactory:PropTypes.func.isRequired,
  };

  return ExtraServicesComp;
};

export default ExtraServicesHOC;
